import React from "react";
import styled from "styled-components";
import * as Router from "next/router";

import * as gtag from "../utils/gtag";
import * as s from "../utils/stream";
import * as U from "./Utils";
import * as h from "../utils/hooks";
import * as T from "./Typography";
import * as I from "./Icons";
import * as UserContext from "./UserContext";

export default function ActivityLike(props) {
  const userInfo = React.useContext(UserContext.Context);
  const router = Router.useRouter();
  const [numLikes, setNumLikes] = React.useState(props.reaction_counts?.like);
  const [activityLikes, setActivityLikes] = React.useState(
    props.latest_reactions.like
  );
  const hasMe = React.useMemo(checkHasMe, [activityLikes]);
  const likeOpts = {
    activity_id: props.id,
    kind: "like",
    limit: 25,
    enrich: true,
  };

  return (
    <S.Container>
      <S.IconContainer onClick={onLike}>
        {hasMe ? <I.HeartActive /> : <I.Heart />}
      </S.IconContainer>
      <U.Space width={3} />
      <T.CM>{numLikes}</T.CM>
    </S.Container>
  );

  function checkHasMe() {
    if (!activityLikes?.length) return false;
    return activityLikes.find((elm) => elm.user_id === userInfo.id);
  }

  async function onLike() {
    if (!userInfo.id) return;
    const client = await s.connect();
    if (hasMe) {
      const reaction_id = activityLikes.find(
        (el) => el.user_id === userInfo.id
      ).id;
      await client?.reactions?.delete(reaction_id);
    } else {
      const targets = ["notification:" + props.actor.id];
      await client?.reactions?.add("like", props.id, null, {
        targetFeeds: targets,
      });
    }

    gtag.event({
      name: gtag.GA_EVENT.PLATFORM_ENGAGEMENT,
      category: "Engagement",
      label: "Like post / comment",
      value: router.route,
    });

    const updatedLikes = await h.getStreamAllReactions(
      likeOpts,
      "like",
      [],
      null,
      client
    );
    setActivityLikes(updatedLikes);
    setNumLikes(updatedLikes.length);
  }
}

const S = {};

S.Container = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
`;

S.Modal = styled.div`
  padding: 20px 40px;
`;

S.ProfileItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0px;
`;

S.Image = styled.img`
  object-fit: cover;
  object-position: 50% 50%;
  width: 60px;
  height: 6px;
  border-radius: 30px;
  background: rgb(243, 196, 150);
  margin-right: 10px;
`;

S.IconContainer = styled.div`
  display: flex;
  align-items: center;
  color: rgb(101, 103, 107);
  svg {
    color: rgb(101, 103, 107);
  }
  :hover {
    cursor: pointer;
    opacity: 0.5;
  }
`;

S.Text = styled.div`
  font-size: 1.4rem;
  color: rgb(101, 103, 107);
  font-weight: 500;
  margin-left: 4px;
  padding-bottom: 1px;
  :hover {
    cursor: pointer;
  }
`;

S.Bold = styled.div`
  font-weight: 600;
  font-size: 1.4rem;
  margin-bottom: 4px;
  margin-left: 14px;
  :hover {
    cursor: pointer;
  }
`;
